import React, { useEffect } from 'react';
import { useAuthModal } from '../context/AuthModalContext';
import { useTheme, TOKENS } from '../context/ThemeContext';
import { supabase } from '../supabase';

export default function AuthModal() {
  const { isOpen, closeAuthModal } = useAuthModal();
  const { theme } = useTheme();
  const c = TOKENS[theme];

  useEffect(() => {
    const handler = (e) => { if (e.key === 'Escape') closeAuthModal(); };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [closeAuthModal]);

  useEffect(() => {
    if (isOpen) document.body.style.overflow = 'hidden';
    else document.body.style.overflow = '';
    return () => { document.body.style.overflow = ''; };
  }, [isOpen]);

  const handleGoogleLogin = async () => {
    await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: { redirectTo: window.location.origin,   },
    });
  };

  if (!isOpen) return null;

  return (
    <div
      onClick={closeAuthModal}
      style={{
        position: 'fixed', inset: 0, zIndex: 1000,
        background: 'rgba(0,0,0,0.6)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: '24px',
      }}>
      <div
        onClick={e => e.stopPropagation()}
        style={{
          background: c.card,
          border: `1px solid ${c.border}`,
          borderRadius: '16px',
          padding: '40px 36px',
          width: '100%',
          maxWidth: '420px',
          textAlign: 'center',
          fontFamily: "'Inter', -apple-system, sans-serif",
          position: 'relative',
        }}>

        {/* Close button */}
        <button
          onClick={closeAuthModal}
          style={{
            position: 'absolute', top: '16px', right: '16px',
            background: 'transparent', border: 'none',
            color: c.muted, cursor: 'pointer', fontSize: '20px', lineHeight: 1,
          }}>✕</button>

        {/* Logo */}
        <div style={{ fontSize: '22px', fontWeight: 800, marginBottom: '8px', color: c.text }}>
          Trail<span style={{ color: c.accent }}>Code</span>
        </div>

        <h2 style={{ fontSize: '20px', fontWeight: 700, margin: '0 0 8px', color: c.text }}>
          Sign in to continue
        </h2>
        <p style={{ fontSize: '14px', color: c.secondary, margin: '0 0 32px', lineHeight: 1.6 }}>
          Track your progress, earn points, and compete on the leaderboard.
        </p>

        <button
          onClick={handleGoogleLogin}
          style={{
            width: '100%',
            background: c.accent,
            color: theme === 'dark' ? c.bg : '#fff',
            border: 'none',
            padding: '13px 24px',
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: '15px',
            fontWeight: 600,
            fontFamily: "'Inter', sans-serif",
            transition: 'opacity 0.15s',
          }}
          onMouseEnter={e => e.target.style.opacity = '0.88'}
          onMouseLeave={e => e.target.style.opacity = '1'}>
          🔵 Continue with Google
        </button>

        <p style={{ fontSize: '12px', color: c.muted, margin: '20px 0 0' }}>
          By signing in you agree to our terms of service.
        </p>
      </div>
    </div>
  );
}